import { RegistryDiscount } from 'src/types/registryDiscount'
import css from './Content.styles.scss'
import {
  SavingsDetail,
  EligibilityWindowDetail,
  CartDetail,
  UsageDetail,
} from './DiscountDetails/Detail'

export const ContentContainer = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <div className={css.RegistryDiscountContent}>
    <div className={css.RegistryDiscountContent__detailsContainer}>
      {children}
    </div>
  </div>
)

export const NotInCohortEligibilityDetails = ({
  registryDiscount,
}: {
  registryDiscount: RegistryDiscount
}) => (
  <ContentContainer>
    <SavingsDetail />
    <EligibilityWindowDetail registryDiscount={registryDiscount} />
    <CartDetail />
  </ContentContainer>
)

export const InCohortEligibilityDetails = ({
  registryDiscount,
}: {
  registryDiscount: RegistryDiscount
}) => (
  <ContentContainer>
    <UsageDetail />
    <EligibilityWindowDetail registryDiscount={registryDiscount} />
    <CartDetail />
  </ContentContainer>
)

export const PreEligibilityDetails = ({
  registryDiscount,
}: {
  registryDiscount: RegistryDiscount
}) => (
  <ContentContainer>
    <SavingsDetail />
    <EligibilityWindowDetail registryDiscount={registryDiscount} />
  </ContentContainer>
)
